import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "../assets/css/Pricing.css";
import { TabView, TabPanel } from 'primereact/tabview';
import { Badge } from 'primereact/badge';
import { Avatar } from 'primereact/avatar';
import { AvatarGroup } from 'primereact/avatargroup';
import Monthlyprice from "../components/Monthlyprice";
import Annualprice from "../components/Annualprice";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { Carousel } from "primereact/carousel";
import { GiTwoCoins } from "react-icons/gi";
import api from "../api/axios";
import { useAuth } from "../context/AuthContext";
import { toast } from "react-toastify";
import CoinCheckoutSidebar from "../components/CoinCheckoutSidebar";
import SEO from "../components/SEO";
const responsiveOptions = [
  { breakpoint: "1200px", numVisible: 4, numScroll: 1 },
  { breakpoint: "992px", numVisible: 2, numScroll: 1 },
  { breakpoint: "576px", numVisible: 1, numScroll: 1 },
];

const Packages = () => {
  const navigate = useNavigate();
  const { isAuthenticated, tierlevel, loading: authLoading } = useAuth();
  const [coinPacks, setCoinPacks] = useState([]);
  const [selectedPack, setSelectedPack] = useState(null);
  const [loadingPacks, setLoadingPacks] = useState(true);
  const [checkoutVisible, setCheckoutVisible] = useState(false);


  const annualHeader = (
    <span className="d-flex align-items-center gap-2">
      Annual
      <Badge value="On Offer" severity="danger" />
    </span>
  );


  /*------------------ Carousel ----------------*/

  const packTemplate = (pack) => {
    return (
      <div
        className={`credit-card overflow-hidden ${selectedPack?.id === pack.id ? "active" : ""
          }`}
        onClick={() => setSelectedPack(pack)}
        style={{ cursor: "pointer", margin: "0 8px" }}
      >
        {!isAuthenticated && (
          <div className="coin-tier-badge">
            {pack.tierName}
          </div>
        )}
        {/* ✅ Show badge only if discount exists */}
        {pack.hasDiscount && pack.discountPercentage && (
          <div className="offerBadge">
            {pack.discountPercentage}% OFF
          </div>
        )}

        <h2>
          <GiTwoCoins /> {pack.credits}
        </h2>

        <h4 className="price d-flex flex-column align-items-center" style={{ letterSpacing: 'normal' }}>
          {pack.hasDiscount && pack.originalPrice ? (
            <>
              <span className="original-price">
                {pack.originalPrice.toLocaleString()} INR
              </span>
              <span className="discounted-price">
                {pack.price.toLocaleString()} INR
              </span>
            </>
          ) : (
            <span className="discounted-price">
              {pack.price.toLocaleString()} INR
            </span>
          )}
        </h4>

        <small>{pack.name}</small>
      </div>
    );
  };




  /* Logged-in users with an active paid subscription should manage the plan on /planupdate, not pricing signup. */
  useEffect(() => {
    if (authLoading) return;
    if (isAuthenticated && Number(tierlevel) > 0) {
      navigate("/planupdate", { replace: true });
    }
  }, [authLoading, isAuthenticated, tierlevel, navigate]);

  useEffect(() => {
    const fetchCoinPacks = async () => {
      try {
        const res = await api.get(`/addcoinrts/coin_packs`);

        if (res.data.success) {
          const formatted = res.data.data.map((pack) => ({
            id: pack.AddCoin_id,
            name: pack.pack_name,
            credits: pack.coin_amount,
            price: Number(pack.pack_value),

            originalPrice: pack.original_pack_value
              ? Number(pack.original_pack_value)
              : null,

            hasDiscount: Boolean(pack.has_discount),

            discountPercentage: pack.discount_percentage
              ? Number(pack.discount_percentage)
              : null,

            tierLevel: Number(pack.tier_level),
            tierName:
              pack.tier_name ||
              {
                1: "Basic",
                2: "Premium",
                3: "Premium Plus",
                4: "Pro",
              }[Number(pack.tier_level)] ||
              "Unknown",

            isActive: Boolean(pack.is_active),
          }));

          // ✅ Backend already filters active, but double-safe
          const activePacks = formatted.filter((p) => p.isActive);

          setCoinPacks(activePacks);

          // ✅ Auto-select middle pack
          if (activePacks.length) {
            setSelectedPack(
              activePacks[Math.floor(activePacks.length / 2)]
            );
          }
        }
      } catch (err) {
        console.error("Fetch coin packs failed:", err);
      } finally {
        setLoadingPacks(false);
      }
    };

    fetchCoinPacks();
  }, []);



  return (
    <>
      <SEO
        title="Pricing"
        description="Browse premium stock images, wallpapers, and digital assets. Discover featured and trending products in our shop."
        canonical="https://shaadimaterial.com/packages"
        keywords="stock images, wallpapers, digital assets, premium images, shop"
        image="https://shaadimaterial.com/logo192.png"
      />
      <Container className="py-5">
        {/* <Row className="mx-0 breadcrumb_part">
            <Breadcrumb>
                <Breadcrumb.Item>Home</Breadcrumb.Item>
                <Breadcrumb.Item active>Pricing</Breadcrumb.Item>
            </Breadcrumb>
        </Row> */}
        <Row className="mx-0 justify-content-center text-center">
          <h1>Pricing</h1>
          <div className="d-flex justify-content-center mb-3 mt-1">
            <AvatarGroup>
              <Avatar image="https://primefaces.org/cdn/primereact/images/avatar/amyelsner.png" shape="circle" />
              <Avatar image="https://primefaces.org/cdn/primereact/images/avatar/asiyajavayant.png" shape="circle" />
              <Avatar image="https://primefaces.org/cdn/primereact/images/avatar/onyamalimba.png" shape="circle" />
              <Avatar image="https://primefaces.org/cdn/primereact/images/avatar/ionibowcher.png" shape="circle" />
              <Avatar image="https://primefaces.org/cdn/primereact/images/avatar/xuxuefeng.png" shape="circle" />
              <Avatar label="Trusted by 700,000+ creative teams, marketers, and designers" shape="circle" className="textBag" />
            </AvatarGroup>
          </div>
        </Row>
        <TabView className="price-tab pb-5">
          <TabPanel header="Monthly">
            <Monthlyprice />
          </TabPanel>
          <TabPanel header={annualHeader}>
            <Annualprice />
          </TabPanel>
        </TabView>

        <hr />

        <Row className="mx-0 py-5 justify-content-center text-center">
          <h2>Finished Already? Get Additional Credits to get what you desire - with Credit Packs .</h2>
          <div className="pt-1 text-center">
            <h5 className="fw-semibold text-secondary mb-5">Explore flexible credit packs and unlock premium designs instantly.</h5>
            <Row className="justify-content-center g-3">
              {loadingPacks ? (
                <h5 className="text-secondary">Loading coin packs...</h5>
              ) : (
                <Carousel
                  value={coinPacks}
                  numVisible={4}
                  numScroll={1}
                  responsiveOptions={responsiveOptions}
                  itemTemplate={packTemplate}
                  circular
                  showIndicators={false}
                  showNavigators
                  className="credit-carousel"
                />
              )}
            </Row>
            <Button
              icon="pi pi-shopping-cart"
              label={
                selectedPack
                  ? `Buy Now for ${selectedPack.price.toLocaleString()} INR`
                  : "Select a coin pack"
              }
              className="mt-5 pricing-subscribe-button"
              style={{ fontSize: "18px" }}
              disabled={!selectedPack}
              tooltip={
                !isAuthenticated
                  ? "Login required to complete purchase."
                  : undefined
              }
              tooltipOptions={{ position: "top" }}
              onClick={() => {
                if (!selectedPack) return;

                if (!isAuthenticated) {
                  navigate("/login", { state: { redirectTo: "/pricing" } });
                  return;
                }
                setCheckoutVisible(true);
              }}
            />


            <div className="cdpack_info">
              <p className="d-flex flex-column gap-0 mt-4 mb-0">
                <span>Credits are valid for 1 year from the date of purchase.</span>
                <span>No auto-renewals — buy more credits only when you need them.</span>
                <span>Use credits to access our full design library, including premium templates.</span>
                <span>Credit usage may vary depending on asset type.</span>
              </p>
            </div>
          </div>
        </Row>
        <hr />
        <Row className="mx-0 justify-content-center text-center pt-5">

          <h2 className="mb-5 d-block">
            Subscription or Credit Top-Ups — How Does It Work?
          </h2>

          <Col
            md={6}
            lg={5}
            xs={12}
            className="mb-3 mb-lg-0"
          >
            <Card className="card-click subvscre">

              <Card.Header className="text-pink">
                Subscriptions
              </Card.Header>

              <Card.Body>

                <p>
                  A subscription is required to access and download content on the platform.
                </p>

                <p>
                  Each plan includes a set number of credits based on your subscription.
                </p>

                <p>
                  Choose the plan that best matches your design, template, 3D, audio and premium asset needs.
                </p>

              </Card.Body>

            </Card>
          </Col>


          <Col
            md={6}
            lg={5}
            xs={12}
            className="mb-3 mb-lg-0"
          >
            <Card className="card-click subvscre">

              <Card.Header className="text-pink">
                Credit Top-Ups
              </Card.Header>

              <Card.Body>

                <p>
                  Credit top-ups are available only to users with an active subscription.
                </p>

                <p>
                  Add extra credits whenever your included subscription credits are not enough.
                </p>

                <p>
                  You can top up your credits as many times as you need while your subscription is active.
                </p>

              </Card.Body>

            </Card>
          </Col>

        </Row>

      </Container>
      <CoinCheckoutSidebar
        visible={checkoutVisible}
        onHide={() => setCheckoutVisible(false)}
        pack={selectedPack}
        isAuthenticated={isAuthenticated}
      />

    </>
  );
};

export default Packages;